import PropTypes from 'prop-types';

import { useContext } from 'react';

import MaterialsCaptureContext from '../../context/MaterialsCaptureContext';

import Box from "@mui/material/Box";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';

import MaterialDivider from './MaterialDivider';
import IgniteMixingForm from './IgniteMixingForm';
import JanusMixingForm from './JanusMixingForm';

const MixingForm = ({ index, data }) => {
  const { 
    handleDelete, handleMixerChange, formErrors
  } = useContext(MaterialsCaptureContext);

  return(
    <Box mt={4}>
      <MaterialDivider 
        index={index} 
        title={'Mixer'} 
        showDeleteIcon={true} 
        handleDelete={handleDelete} 
        deleteIndex={data?.index} 
      />

      <Box mt={1}>
        <FormControl error={`method-${data?.index}` in formErrors}>
          <RadioGroup
            row
            aria-labelledby="mixer"
            name={`mixer-${data?.index}`}
            value={data?.mixer}
            onChange={e => handleMixerChange(data?.index, e.target.value)}
          >
            <FormControlLabel value="Janus" control={<Radio />} label="Janus" />
            <FormControlLabel value="Ignite" control={<Radio />} label="Ignite" />
          </RadioGroup>
          <FormHelperText>{formErrors[`method-${data?.index}`]}</FormHelperText>
        </FormControl>

        {data?.mixer === 'Janus' && <JanusMixingForm data={data} />}
        {data?.mixer === 'Ignite' && <IgniteMixingForm data={data} />}
      </Box>
    </Box>
  );
};

MixingForm.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default MixingForm;